import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { MuiThemeProvider, CssBaseline } from '@material-ui/core';
import { store } from './store/config/configureStore';
import Main from './screens/Main';
import { theme } from './styles/theme';
import './styles/app.scss';
import WarehouseWorkService from './services/warehouseWork.service';
import { createContext, useEffect, useState } from 'react';
import { TargetDateProvider } from './store/context/date.context';

export const ApiQueueInfoContext = createContext<any>(null);

function App() {
  const [apiQueueInfo, setApiQueueInfo] = useState<any>(null);
  const inqueryApiCallQueue = () => {
    WarehouseWorkService.getApiQueueInfo()
      .then((info) => {
        if (info.sum != apiQueueInfo.sum) {
          setApiQueueInfo(info);
        }
        if (info !== null) {
          setTimeout(() => {
            inqueryApiCallQueue();
          }, 10000);
        }
      })
      .catch(() => {
        setTimeout(() => {
          inqueryApiCallQueue();
        }, 30000);
      });
  };
  useEffect(() => {
    inqueryApiCallQueue();
  }, []);
  return (
    <ApiQueueInfoContext.Provider value={apiQueueInfo}>
      <TargetDateProvider>
        <Provider store={store}>
          <MuiThemeProvider theme={theme}>
            <BrowserRouter>
              <CssBaseline />
              <Main />
            </BrowserRouter>
          </MuiThemeProvider>
        </Provider>
      </TargetDateProvider>
    </ApiQueueInfoContext.Provider>
  );
}

export default App;
